<template lang="pug">
  .purchases.xs-12
    FixedWidthTweakUpper
      template(v-if="cdata.ordersTotal > 0")
        .history-addons-section.section(v-if="$root.historyAddons.length && subsGroupedByNextWithOnTheWay && !subsGroupedByNextWithOnTheWay.length")
          .xs-12.text-center
            SectionTitle(text="Purchases")

          .one-time-wrap.xs-12(v-for="(addon, index) in $root.historyAddons" v-if="index < 1")
            .prod-wrap.xs-12
              ProductInfoImage.xs-4.md-6(:imagery="addon.imagery")

              .prod-info.xs-8.md-6
                p.upper.bold.xs-f-small.max-at-tweak {{addon.product_type_display_name}}
                p.color-slate.xs-f-small.max-at-tweak {{addon.name}}

            SubscribeWithBenefits(v-if="addon.product_type_renewable" :product="addon")

            .one-time-cta.xs-12(v-else)
              a.mr-btn.btn-block.xs-f-xsmall.max-at-tweak(:href="'/product/' + addon.url_key") buy again

        .grouped-subs-section.section(v-if="subsGroupedByNextWithOnTheWay && subsGroupedByNextWithOnTheWay.length")
          .xs-12.text-center
            SectionTitle(:text="groupedTitle")
          .subscription-groups.xs-12
            .xs-12(v-if="subsGroupedByNextWithOnTheWay.length")
            .subscription-group.xs-12(v-for="group in subsGroupedByNextWithOnTheWay")
              .on-the-way.xs-12(v-if="onTheWaySubsMap[group[0].id]")
                p.on-the-way-text.xs-f-small.lg-f-medium.max-at-tweak
                  i.icon-truck.color-slate.xs-f-large.max-at-tweak
                  span.xs-f-small.lg-f-medium.max-at-tweak &nbsp;{{group.length > 1 ? 'These items are on the way' : 'This item is on its way'}}
                a.tracking-link.xs-f-small.lg-f-medium.max-at-tweak(v-if="onTheWaySubsMap[group[0].id].trackingUrl" :href="onTheWaySubsMap[group[0].id].trackingUrl") Track&nbsp;
                  span.icon-caret-right.xs-f-large.max-at-tweak
              .xs-12(v-else)
                p
                  span.upper.color-slate.xs-f-xsmall.lg-f-small.max-at-tweak Next Shipment
                  br
                  span.bold.xs-f-medium.max-at-tweak {{group[0].next | moment("MMM D")}}

              .subscription-wrap.xs-12(v-for="sub in group" v-if="sub.product_info")
                .prod-wrap.xs-12
                  ProductInfoImage.xs-4.md-4(:imagery="sub.product_info.imagery")

                  .prod-info.xs-8.md-4
                    p.upper.bold.xs-f-xsmall.lg-f-small.max-at-tweak {{sub.product_info.product_type_display_name}}
                    p.color-slate.xs-f-xsmall.xs-f-small.max-at-tweak {{sub.product_info.name}}
                    p.color-slate.xs-f-xsmall.xs-f-small.max-at-tweak Every {{sub.subFrequency}} weeks
                    router-link.xs-f-xsmall.xs-f-small.max-at-tweak(v-if="group.length > 1" :to="'/dashboard/purchases/edit-auto-delivery/' + sub.id" ) Manage

                  .single-subscription-ctas.xs-12.md-4(v-if="group.length == 1")
                    template(v-if="!onTheWaySubsMap[group[0].id]")
                      a.mr-btn.xs-f-xsmall.max-at-tweak(@click="shipNow({ subId: sub.id })") ship now
                      a.mr-btn.btn-inverse.xs-f-xsmall.max-at-tweak(@click="openPostponeModal({ subId: sub.id })") postpone
                    router-link.mr-btn.btn-inverse.xs-f-xsmall.max-at-tweak(:to="'/dashboard/purchases/edit-auto-delivery/' + sub.id" :class="{'btn-block': onTheWaySubsMap[group[0].id]}" data-mr-ass="manage-sub-button") {{onTheWaySubsMap[group[0].id] ? 'manage' : 'more...'}}

              .multi-subscription-ctas.xs-12(v-if="group.length > 1 && !onTheWaySubsMap[group[0].id]")
                a.mr-btn.btn-block.xs-f-xsmall.max-at-tweak(@click="shipNow({ subId: group[0].id, includeSubsWithSameNext: true })") Ship {{group.length}} subscriptions now

        .inactive-subs-section.section(v-if="promotedReactivatableSubs && promotedReactivatableSubs.length")
          .xs-12.text-center
            SectionTitle(text="Inactive Subscriptions" data-mr-ass="inactive-subs-view")
          .subscriptions-wrap.xs-12
            .subscription-wrap.xs-12(v-for="sub in promotedReactivatableSubs")
              .xs-12
                p.color-slate.xs-f-xsmall.lg-f-small.max-at-tweak(data-mr-ass="inactive-sub-text") Subscription stopped on {{sub.last_canceled_at | moment("MMM DD, YYYY")}}
              .prod-wrap.xs-12
                ProductInfoImage.xs-4(:imagery="sub.product_info.imagery")

                .prod-info.xs-8.md-4
                  p.upper.bold.xs-f-xsmall.lg-f-small.max-at-tweak {{sub.product_info.product_type_display_name}}
                  p.color-slate.xs-f-xsmall.xs-f-small.max-at-tweak {{sub.product_info.name}}

                .xs-12.md-4
                  router-link.reactivate-cta.mr-btn.btn-block.xs-f-xsmall.max-at-tweak(:to="'/dashboard/purchases/edit-auto-delivery/' + sub.id" data-mr-ass="reactivate-sub") reactivate

        SectionLink(v-if="inactiveSubs.length" url="/dashboard/purchases/inactive-auto-delivery" link-text="Inactive Subscriptions")

        SectionLink(url="/dashboard/purchases/orders" link-text="All Purchases" data-mr-ass="all-purchases-button")

        .forty-five-plus-shades.section(v-if="!hasActiveColorSubscription && !hasInactiveColorSubscription")
          .absolute-wrap
            img-box(media-id="5031")
          .inner-wrap.xs-12.text-center
            p.didot.upper.color-white.xs-f-xxlarge.sm-f-xgrande.md-f-xxgrande.lg-f-xxxgrande.max-at-tweak 45+ Shades
            a.mr-btn.btn-white-inverse.xs-f-xsmall.max-at-tweak(href="/shop/hair-color?rectype=color") find your perfect shade

      template(v-else)
        SectionBlock.no-orders-section(title="orders")
          .xs-12.text-center
            p.no-orders-text.color-slate.xs-f-small.lg-f-medium.max-at-tweak There are no orders to display
            a.mr-btn.btn-fixed-width.xs-f-xsmall.max-at-tweak(href="/shop/hair-color?rectype=color") find your perfect shade

      ExpertiseIncluded

</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';
  import ExpertiseIncluded from '../../ExpertiseIncluded';
  import ProductInfoImage from './ProductInfoImage';
  import SectionBlock from '../SectionBlock';
  import SectionLink from "../SectionLink";
  import SectionTitle from "../../SectionTitle";
  import BenefitsTable from "../BenefitsTable";
  import SubscribeWithBenefits from "../SubscribeWithBenefits";
  import FixedWidthTweakUpper from "../../FixedWidthTweakUpper";

  export default {
    name: 'Purchases',

    components: {
      FixedWidthTweakUpper,
      SubscribeWithBenefits,
      SectionBlock,
      SectionTitle,
      SectionLink,
      ExpertiseIncluded,
      ProductInfoImage,
      BenefitsTable
    },

    data() {
      return {
        oneTimeProducts: []
      }
    },

    beforeCreate() {
      this.$store.dispatch('customer/getRecentInvoices');
      this.$store.dispatch('subscriptions/initSubscriptions');
    },

    computed: {
      ...mapState('subscriptions', ['subs']),
      ...mapGetters('subscriptions', [
        'subsGroupedByNextWithOnTheWay',
        'inactiveSubs'
      ]),

      ...mapState('customer', ['cdata', 'recentInvoices']),
      ...mapGetters('customer', ['onTheWaySubsMap']),

      hasActiveColorSubscription() {
        var activeColorSub = false;

        this.subs.forEach(sub => {
          if (sub.status == 'active' && sub.product_info.product_type == 'color_kit') {
            activeColorSub = true;
          }
        });

        return activeColorSub;
      },

      hasInactiveColorSubscription() {
        var inactiveColorSub = false;

        this.subs.forEach(sub => {
          if (sub.status == 'canceled' && sub.product_info.product_type == 'color_kit') {
            inactiveColorSub = true;
          }
        });

        return inactiveColorSub;
      },

      activeSubTypes() {
        var activeSubTypes = {};

        this.subs.forEach(sub => {
          if (sub.status == 'active') {
            activeSubTypes[sub.product_info.product_type] = true;
          }
        });

        return activeSubTypes;
      },

      promotedReactivatableSubs() {
        var promotedSubs = [];
        
        if (this.hasActiveColorSubscription) {
          for (var x = 0; x < this.inactiveSubs.length; x++) {
            if (!this.activeSubTypes[this.inactiveSubs[x].product_info.product_type]) {
              promotedSubs.push(this.inactiveSubs[x]);
            }
            if (promotedSubs.length >= 2) {
              x = this.inactiveSubs.length;
            }
          }
        }

        if (!this.hasActiveColorSubscription && this.hasInactiveColorSubscription) {
          for (var x = 0; x < this.inactiveSubs.length; x++) {
            if (this.inactiveSubs[x].product_info.product_type == 'color_kit') {
              promotedSubs.push(this.inactiveSubs[x]);
            }
            if (promotedSubs.length >= 2) {
              x = this.inactiveSubs.length;
            }
          }
        }

        return promotedSubs;
      },

      groupedTitle() {
        return `Subscription${this.subsGroupedByNextWithOnTheWay.length > 1 ? 's' : ''}`;
      }
    },

    methods: {
      ...mapActions('subscriptions', [
        'populateSubInEditById',
        'shipNow',
        'openPostponeModal'
      ])
    }
  }
</script>

<style scoped lang="stylus">
  .purchases
    .prod-wrap
      .prod-info
        padding-left 1em
        
        p
          padding-bottom 0.5em
      
    .history-addons-section
      padding 1.5em 0 !important
      
      .prod-wrap
        padding 1.5em 5%
      
      .one-time-cta
        padding 0 5%
        padding-bottom 1.5em

    .grouped-subs-section
      .subscription-group
        padding 2em 0
        border-bottom 1px solid #ccc
        
        &:last-child
          border-bottom none
          padding-bottom 0.5em
          
        .on-the-way
          background-color #e6eef6
          padding 0.5em 3%
          
          .on-the-way-text
            display inline-block
            padding 1em 0
            
          .tracking-link
            float right
            padding 1em 0
            padding-left 1em
        
        .subscription-wrap
          padding-top 1.5em
        
      .multi-subscription-ctas
      .single-subscription-ctas
        padding-top 1.5em
        
      .single-subscription-ctas
        .mr-btn
          margin-right 0.75em
          
          &:last-child
            margin-right 0
    
    .inactive-subs-section
      .subscriptions-wrap
        .subscription-wrap
          padding 1.5em 0
          border-bottom 1px solid #ccc
          
          &:last-child
            padding-bottom 0.5em
            border-bottom none
        
      .prod-wrap
        padding-top 1.5em
        
      .reactivate-cta
        padding-left 1em
        padding-right 1em
        margin-top 1.5em
            
    .forty-five-plus-shades      
      .mr-btn
        margin-top 1.5em
        margin-bottom 0.5em
        
    .no-orders-section
      padding-bottom 3em !important
      
      .no-orders-text
        padding-bottom 1.5em

    @media mq-mobile
      .grouped-subs-section
        .single-subscription-ctas
          .mr-btn
            padding 1em 0.5em
    
    @media mq-tablet
      .history-addons-section
        .prod-wrap
          padding 1.5em 10%
          
        .subscribable-cta
          .cta-wrap
            padding 1em 15%
            
        .one-time-cta
          padding 0 10%
          padding-bottom 1.5em
          
      .grouped-subs-section
      .inactive-subs-section
        padding 1.5em 7% !important
          
    @media mq-desktop-md-plus
      .grouped-subs-section
        .single-subscription-ctas
          padding-top 0
          
          .mr-btn
            width 100%
            margin-bottom 0.75em
            
    @media mq-desktop-md
      .history-addons-section
        .prod-wrap
          padding 1.5em 25%
          
        .subscribable-cta
          .cta-wrap
            padding 1em 28%
        
        .one-time-cta
          padding 0 25%
          padding-bottom 1.5em
      
      .grouped-subs-section
      .inactive-subs-section
        padding 1.5em 8% !important
        
      .grouped-subs-section
        .single-subscription-ctas
          padding-left 5%
          
    @media mq-desktop-plus
      .history-addons-section
        .prod-wrap
          padding 1.5em 30%
          
        .subscribable-cta
          .cta-wrap
            padding 1em 32%
        
        .one-time-cta
          padding 0 30%
          padding-bottom 1.5em
      
      .grouped-subs-section
      .inactive-subs-section
        padding 1.5em 10% !important
        
      .grouped-subs-section
        .single-subscription-ctas
          padding-left 5%
          
</style>
